// src/components/ui/SheetHeader/styles.ts
import styled from "styled-components";

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px 18px 12px;
`;

export const Titles = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Title = styled.div`
  font-family: ${(p) => p.theme.tokens.font.family};
  font-weight: 900;
  font-size: 19px;
  color: ${(p) => p.theme.tokens.colors.ink};
  letter-spacing: -0.3px;
`;

export const Sub = styled.div`
  font-family: ${(p) => p.theme.tokens.font.family};
  font-size: 13px;
  color: ${(p) => p.theme.tokens.colors.muted};
  margin-top: 2px;
`;

export const CloseButton = styled.button`
  width: 34px;
  height: 34px;
  border-radius: 17px;
  border: none;
  background: ${(p) => p.theme.tokens.colors.softBg};
  color: #41524d;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
`;
